import React from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage, Link } from 'anf-core-react';
import { usePhoneLinkParser } from '../../hooks/usePhoneLinkParser';

/**
 * PaymentStatusBanner - Displays error or success banners for WSS payment flow
 */
function PaymentStatusBanner({ message, type }) {
  const parseWithLinks = usePhoneLinkParser();

  if (!message || !message.value) {
    return null;
  }

  const parseMessageWithPhoneLinks = (text) => parseWithLinks(text)
    .map((p, idx) => ({ ...p, key: `${p.type}-${idx}` }));

  const messageElements = parseMessageWithPhoneLinks(message.value);

  if (type === 'error') {
    return (
      <div className="wss-payment-status-banner">
        <ErrorMessage id={`wss-payment-${type}-message`}>
          {messageElements.map((element) => (
            element.type === 'text'
              ? <span key={element.key}>{element.content}</span>
              : (
                <Link key={element.key} classList="link-phoneNumber" href={element.href}>
                  {element.content}
                </Link>
              )
          ))}
        </ErrorMessage>
      </div>
    );
  }

  return (
    <div className="wss-payment-status-banner">
      <div
        className={`wss-banner-message wss-banner-${type}`}
        role="status"
        aria-live="polite"
      >
        {messageElements.map((element) => (
          element.type === 'text'
            ? <span key={element.key}>{element.content}</span>
            : (
              <Link key={element.key} classList="link-phoneNumber" href={element.href}>
                {element.content}
              </Link>
            )
        ))}
      </div>
    </div>
  );
}

PaymentStatusBanner.propTypes = {
  message: PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  }),
  type: PropTypes.oneOf(['error', 'success']),
};

PaymentStatusBanner.defaultProps = {
  message: null,
  type: 'error',
};

export default PaymentStatusBanner;
